import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle2, XCircle } from "lucide-react";
import { LucideIcon } from "lucide-react";

interface SolutionCardProps {
  icon: LucideIcon;
  title: string;
  before: string;
  after: string;
}

const SolutionCard = ({ icon: Icon, title, before, after }: SolutionCardProps) => {
  return (
    <Card className="hover:shadow-lg transition-all duration-300 border-primary/20 hover:border-primary/40">
      <CardHeader>
        <div className="flex items-center gap-3 mb-2">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon className="h-5 w-5 text-primary" />
          </div>
          <CardTitle className="text-lg">{title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-start gap-2">
          <XCircle className="h-5 w-5 text-destructive mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-muted-foreground">Before:</p>
            <p className="text-sm">{before}</p>
          </div>
        </div>
        <div className="flex items-start gap-2">
          <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-muted-foreground">After:</p>
            <p className="text-sm">{after}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SolutionCard;
